module.exports = __webpack_public_path__ + "static/GasSafe-a7302d9320494ea311b66950a352aa0a.png";